import styled from "styled-components";

export const Container = styled.ul`
  width: 100%;
  margin-top: 1.875rem;
`;
